import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MasterDepartmentService } from 'src/app/services/master-department.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { GeneralAreaComponent } from "../general-area/general-area.component";
//import { GeneralDepartmentComponent } from "../general-department/general-department.component";
//import { GeneralShiftComponent } from "../general-shift/general-shift.component";
import { Router } from '@angular/router';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { MachineMappingService } from 'src/app/services/machinemapping.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
import { generalSubDept } from '../general-subDepartment/generalSubDept.component';
@Component({
  selector: 'app-general-category',
  templateUrl: './general-category.component.html',
  styleUrls: ['./general-category.component.scss']
})
export class GeneralCategoryComponent implements OnInit {
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  filteredModules!: any[];
  filteredModule!: any[];
  groupList!: any[];
  plantList!: any[];
  searchMasterForm!: FormGroup;
  breadcrumList!: any;
  groupListDDL!:any[];
  permisson!: any;
  IsAccess!: any;
  IsWrite!: any;
  GroupId!: number;
  lang: any;
  @ViewChild(GeneralAreaComponent) GeneralAreaComponent!: GeneralAreaComponent;
  //@ViewChild(GeneralDepartmentComponent) GeneralDepartmentComponent!: GeneralDepartmentComponent;
  //@ViewChild(GeneralShiftComponent) GeneralShiftComponent!: GeneralShiftComponent;
  @ViewChild(generalSubDept) generalSubDepartment: generalSubDept;
  constructor(private machineService : MachineMappingService,public translater: TranslaterService,
    public translate: TranslateService,private toaster: ToastrService,private roleService: MasterDepartmentService,private fb: FormBuilder,private breadcum: UserManagementService,public router: Router,private enterpriseGroupService: EnterPriseGroupService,) {this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();}); }

  ngOnInit() {
    this.getGroupsData();
    this.GetBreadcrumList();
    this.searchMasterForm = this.fb.group({
      group: ['', Validators.required],
      plant: ['', Validators.required]
    });
  }
 
  getGroupsData(): void {
    // this.spinner.show();
    const key = {
      Id: 0,
    };

    this.roleService.getGroupData(key).subscribe((data: any) => {
      this.groupList = data.masterList;
      this.searchMasterForm.get('group')?.setValue(this.groupList[0].TypeId);
      this.getPlantData();
      if (this.groupList.length > 0) {
        this.filteredModules = this.groupList.slice();
      }
    },
      (error:any) => {
        this.toaster.error('Error', error.error.message);
      //  this.spinner.hide();
      }
    );
  }
  getMasterData(): void {
    const key = {
      egId: this.searchMasterForm.value.group,
      plantId: this.searchMasterForm.value.plant
    };
    //this.GeneralDepartmentComponent.getdepartmentList(key);
    this.generalSubDepartment.getDepartments(key.plantId);
    this.generalSubDepartment.getSubDepartment(key.plantId);

    this.GeneralAreaComponent.getareaList(key);
    //this.GeneralShiftComponent.getshiftList(key);
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
    // return false;
  }
  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.enterpriseGroupService.GetMenuAccess(key).subscribe(
      (data: any) => {
        this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  getPlantData(): any {
    const key = {
      GroupId : this.searchMasterForm.value.group
    };
    this.machineService.getPlantsData(key).subscribe((data: any) => {
      this.plantList = data.DepartList;
      this.searchMasterForm.get('plant')?.setValue(data.DepartList[0].DeptId);
      this.getMasterData();
      if (this.plantList.length > 0) {
        this.filteredModule = this.plantList.slice();
      }
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }

  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.breadcum.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater,this.translate);
        this.lang.getLangWords();
      },
      (error: any) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
}
